import React from "react";
import "./footer.css";
import Fade from "react-reveal/Fade";

const Footer = () => {
  return (
    <section className="Footer_Main_Container" id="Footer_Section">
      <div className="Divider_Style"></div>
      <Fade top>
        <div className="Footer_Text_Wrapper">
          <p className="Footer_Text_Style">
            @2022 Alpha Swap, All Righs Reserved.
          </p>
          <p className="Footer_Text_Style">ENS: Alpha Swap.eth</p>
          <p className="Footer_Text_Style">BUIDL@ETHNewYork 2023</p>
        </div>
      </Fade>
    </section>
  );
};

export default Footer;
